// Helpers for converting between the string values form controls hold and the nullable
// number / boolean shapes the API expects. An empty string means "not answered" and
// maps to null. See @/types/form-values for the TYesNo / TYesNoUnknown unions.
import type { TYesNo, TYesNoUnknown } from '@/types/form-values';

/** Parses a form string to an integer, or null when blank. */
export const toIntOrNull = (value: string): number | null => value !== '' ? parseInt(value, 10) : null;

export const toBoolOrNull = (value: string): boolean | null => value !== '' ? value === '1' : null;

export const asString = (value: number | null) => (value != null ? String(value) : '');

export const asStringBool = (value: boolean | null): TYesNo => (value != null ? value == true ? '1' : '0' : '');

/** Nkr.Model.Enums.YesNoUnknown (Unknown = -1, No = 0, Yes = 1) as a form value. */
export const asStringYesNoUnknown = (value: number | null): TYesNoUnknown =>
    value === 1 ? '1' : value === 0 ? '0' : value === -1 ? '-1' : '';
